import React, { Fragment } from 'react';
import {
  Container,
  Divider,
  Dropdown,
  Grid,
  Header,
  Image,
  List,
  Menu,
  Segment,
  Modal,
  Icon,
  Button,
} from 'semantic-ui-react';
// import logo from "./logo.png";
import './App.css';
import NoSleep from 'nosleep.js';
import { Howl, Howler } from 'howler';

class App extends React.Component {
  constructor(props) {
    super(props);
    this.sound = new Howl({
      src: 'https://media.login.in.th:8443/smilehost/8135',
      html5: true,
    });
    this.noSleep = new NoSleep();

    this.state = {
      open: false,
      isLine: true,
      isAndroid: true,
      isPlaying: false,
    };
  }

  handleClick = () => {
    let isPlaying = this.state.isPlaying;
    if (isPlaying) {
      this.sound.stop();
      document.getElementById('app-logo').classList.remove('App-logo');
    } else {
      this.sound.play();
      document.getElementById('app-logo').classList.add('App-logo');
    }
    this.setState({
      isPlaying: !isPlaying,
    });

    console.log('play');
  };

  componentDidMount() {
    var that = this;
    var btn = document.getElementById('play');

    btn.addEventListener(
      'click',
      function enableNoSleep() {
        console.log('nosleep');
        // that.setState({ open: true });
        btn.removeEventListener('click', enableNoSleep, false);
        that.noSleep.enable();
      },
      false,
    );

    let ua = navigator.userAgent.toLowerCase();
    let isLine = ua.match(/line/i) == 'line';
    let isAndroid = false;

    if (isLine) {
      if (ua.match(/android/i)) {
        isAndroid = true;
      }
    }

    this.setState({
      isLine,
      isAndroid,
    });
  }

  close = () => this.setState({ open: false });

  render() {
    return (
      <div className="App">
        <Modal
          open={this.state.open}
          basic
          size="large"
          closeIcon
          onClose={this.close}
          centered={false}
        >
          <Header icon="play" content="ฟังไปเล่นไลน์ไป" />
          <Modal.Content>
            <List ordered inverted size="huge">
              {this.state.isAndroid && (
                <Fragment>
                  <List.Item>
                    กดปุ่มมุมขวาบน <Icon fitted name="ellipsis vertical" />
                  </List.Item>
                  <List.Item>
                    เลือก <Icon fitted name="share square" />
                    Open in other app
                  </List.Item>
                </Fragment>
              )}
              {!this.state.isAndroid && (
                <Fragment>
                  <List.Item>
                    กดปุ่มแชร์มุมขวาบน <Icon fitted name="share square" />
                  </List.Item>
                  <List.Item>เลือก 'Open in Safari'</List.Item>
                </Fragment>
              )}
            </List>
            {/* <p>{this.state.isAndroid + 1}</p> */}
          </Modal.Content>
        </Modal>
        <Menu fixed="top" inverted size="massive">
          <Container>
            <Menu.Item>
              <Image
                size="small"
                src={process.env.PUBLIC_URL + '/logo-text.png'}
                style={{ marginRight: '1.5em' }}
                href="https://fm101talk.com"
              />
            </Menu.Item>
            {/* <Menu.Item>
              <span style={{ fontSize: "0.6em", wordBreak: "break-word" }}>
                ติดต่อโฆสนา: 02-639-4581-2 (ต่อ 107)
              </span>
            </Menu.Item> */}
            {/* <Menu.Item as="a">ชุมชน 101</Menu.Item> */}
          </Container>
        </Menu>
        <div id="player-wrapper">
          <Segment id="player" inverted>
            <img
              src={process.env.PUBLIC_URL + '/logo512.png'}
              // className="App-logo"
              alt="logo"
              id="app-logo"
            />
            <div>
              <Divider horizontal inverted>
                LIVE
              </Divider>
              <Button icon size="massive" id="play" onClick={this.handleClick}>
                <Icon name={this.state.isPlaying ? 'stop' : 'play'} />
              </Button>
            </div>
          </Segment>
        </div>
        <Menu inverted size="massive" stackable compact={true}>
          <Menu.Item as="a" href="https://line.me/R/ti/p/%40fm101talk">
            <Image
              size="mini"
              src={process.env.PUBLIC_URL + '/line.png'}
              style={{ marginRight: '1.5em' }}
            />
            @FM101TALK
          </Menu.Item>
          <Menu.Item as="a" href="https://www.facebook.com/FM101Talk">
            <Image
              size="mini"
              src={process.env.PUBLIC_URL + '/facebook.png'}
              style={{ marginRight: '1.5em' }}
            />
            FM101TALK
          </Menu.Item>
          <Menu.Item
            as="a"
            href="https://www.youtube.com/channel/UCg1A0_SlcnPqSrZnOKY38wA"
          >
            <Image
              size="mini"
              src={process.env.PUBLIC_URL + '/youtube.png'}
              style={{ marginRight: '1.5em' }}
            />
            FM101TALK
          </Menu.Item>
          {/* <Menu.Item as="a">ชุมชน 101</Menu.Item> */}
        </Menu>
        <br />
        {this.state.isLine && (
          <Button
            content="วิธีฟังไปเล่นไลน์ไป"
            color="red"
            onClick={() => this.setState({ open: true })}
          />
        )}
        <br />
        <Image src={process.env.PUBLIC_URL + '/schedule-04-2020.png'} fluid />
      </div>
    );
  }
}

export default App;
